import { render, staticRenderFns } from "./PortalCard.vue?vue&type=template&id=0775bafc&scoped=true"
import script from "./PortalCard.vue?vue&type=script&lang=js"
export * from "./PortalCard.vue?vue&type=script&lang=js"
import style0 from "./PortalCard.vue?vue&type=style&index=0&id=0775bafc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0775bafc",
  null
  
)

export default component.exports